import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router";
import axios from "axios";
import JoditEditorComponent from "../shared/JoditEditorComponent";
const _ = require('lodash');
const MyResumeEdit = ({ myResume }) => {
  const [loading, setloading] = useState(false)
  const navigate = useNavigate();
  const userid = localStorage.getItem("userid");
  const initialValuesResume = {
    userid: userid,
    resume_id: '',
    heading: "",
    skills: "",
    jobCategory: "",
    jobType: "",
    jobLevel: "",
    expectedSalary: "",
    totalexperience: "",
    knownlanguage: "",
    dob: "",
    maritalStatus: "",
    candidate_address: "",
    self_description: "",
    educationTitle: "",
    degree: "",
    institute: "",
    educationYear: "",
    educationDescription: "",
    designation: "",
    organization: "",
    currentSalary: "",
    jobDuration: "",
    jobLocation: "",
    jobDescription: "",
    projecttitle1: "",
    projecttitle2: "",
    projectdescription1: "",
    projectdescription2: "",
    portfolioUrl: "",
    linkedinUrl: ""
  };
  const [updateData, SetUpdateData] = useState(initialValuesResume);
  const validationSchema = Yup.object({
    heading: Yup.string().required("Please Enter Heading"),
    skills: Yup.string().required("Please Enter Some Skills"),
    jobCategory: Yup.string().required("Please Select a Job Category"),
    jobType: Yup.string().required("Please select a Job Type"),
    jobLevel: Yup.string().required("Please select a Job Level"),
    dob: Yup.string().required("Please Enter Date Of Birth"),
    educationTitle: Yup.string().required("Please Enter Title"),
    degree: Yup.string().required("Please Enter Degree Name"),
    institute: Yup.string().required("Please Enter Institute Name"),
    educationYear: Yup.string().required("Please Enter year in specific format"),
    designation: Yup.string().required("Please Enter Designation"),
    organization: Yup.string().required("Please Enter organization Name"),
    currentSalary: Yup.number().typeError("Please Enter Current Salary"),
    jobDuration: Yup.string().required("Please Enter Job Duration"),
    jobLocation: Yup.string().required("Please Enter Job Location"),
    linkedinUrl: Yup.string()
      .matches(
        /^(https?:\/\/)?(www\.)?linkedin\.com\/.+$/,
        "Please Enter A Valid LinkedIn URL"
      )
      .required("LinkedIn URL is required")
  });
  const handleUpdate = async (values) => {
    setloading(true)
    try {
      const url = process.env.REACT_APP_API_URL + "resume/updateresume";
      const response = await axios.put(url, values);
      alert("Updated successfully");
      navigate('/candidatedashboard');
    } catch (error) {
      alert("Unable to update please try after some time ")
      console.error(error)

    }
    finally {
      setloading(false)
    }
  };
  useEffect(() => {
    SetUpdateData(myResume);
  }, [myResume])
  return (
    <div className="col-lg-9">
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">My Resume</h4>
          <div className="profile-resume">
            <div className="profile-form">
              <Formik
                enableReinitialize={true}
                initialValues={updateData}
                validationSchema={validationSchema}
                onSubmit={async (values) => {

                  if (_.isEqual(values, updateData)) {
                    alert("No Updates made");
                  }
                  else {
                    await handleUpdate(values);

                  }
                }
                }
              >
                <Form action="#">
                  <h6 className="mb-3">Resume Heading</h6>
                  <div className="form-group">
                    <label>Heading</label>
                    <Field name="heading" type="text" className="form-control" placeholder="I am a FullStack Developer " />
                    <ErrorMessage name="heading" component="div" className="text-danger" />
                  </div>
                  <h6 className="mb-3">Key Skills</h6>
                  <div className="form-group">
                    <label>Skills</label>
                    <Field name="skills" type="text" className="form-control" placeholder="Enter Skills Ex: Figma, Adobe XD" />
                    <ErrorMessage name="skills" component="div" className="text-danger" />
                  </div>
                  <h6 className="mb-3">Working Preferences</h6>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Job Category</label>
                        <Field as="select" name="jobCategory" className="form-control">
                          <option value="">Choose Category</option>
                          <option value="1">Web Designer</option>
                          <option value="2">Developer</option>
                          <option value="3">Software</option>
                          <option value="4">Finance</option>
                          <option value="5">Management</option>
                          <option value="6">Advertising</option>
                          <option value="7">Accountant</option>
                        </Field>
                        <ErrorMessage name="jobCategory" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Job Type</label>
                        <Field as="select" name="jobType" className="form-control">
                          <option value="">Choose Type</option>
                          <option value="1">Full Time</option>
                          <option value="2">Part Time</option>
                          <option value="3">Remote</option>
                          <option value="4">Freelancer</option>
                          <option value="5">Temporary</option>
                        </Field>
                        <ErrorMessage name="jobType" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Job Level</label>
                        <Field as="select" name="jobLevel" className="form-control">
                          <option value="">Choose Level</option>
                          <option value="1">Senior</option>
                          <option value="2">Junior</option>
                        </Field>
                        <ErrorMessage name="jobLevel" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Expected Salary(In LPA)</label>
                        <Field name="expectedSalary" type="text" className="form-control" placeholder="Enter Expected Salary" />
                        <ErrorMessage name="expectedSalary" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Total Experience(Years)</label>
                        <Field name="totalexperience" type="number" className="form-control" placeholder="Enter Experience" />
                        <ErrorMessage name="totalexperience" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="form-group">
                        <label>Language</label>
                        <Field name="knownlanguage" type="text" className="form-control" placeholder="Enter Language Ex: English, German" />
                        <ErrorMessage name="knownlanguage" component="div" className="text-danger" />
                      </div>
                    </div>
                    <h6 className="mb-3">Personal Detailes</h6>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Date Of Birth</label>
                        <Field name="dob" type="date" className="form-control" placeholder="Enter Date Of Birth" />
                        <ErrorMessage name="dob" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Marital Status</label>
                        <Field as="select" name="maritalStatus" className="form-control">
                          <option value="">Choose Marital Status</option>
                          <option value="1">Yes</option>
                          <option value="2">No</option>
                        </Field>
                        <ErrorMessage name="maritalStatus" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Address</label>
                        <Field name="candidate_address" type="text" className="form-control" placeholder="Enter Your Address" />
                        <ErrorMessage name="candidate_address" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Description</label>
                        <Field name="self_description" className="form-control" component={JoditEditorComponent} type="text"  />
                        <ErrorMessage name="self_description" component="div" className="text-danger" />
                      </div>
                    </div>
                    <h6 className="mb-3">Education/Qualifications</h6>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Title</label>
                        <Field name="educationTitle" type="text" className="form-control" placeholder="Enter Title (Ex: Master's)" />
                        <ErrorMessage name="educationTitle" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Degree</label>
                        <Field name="degree" type="text" className="form-control" placeholder="Enter Degree Name (Ex: Data Science)" />
                        <ErrorMessage name="degree" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Institute</label>
                        <Field name="institute" type="text" className="form-control" placeholder="Enter Institute" />
                        <ErrorMessage name="institute" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Year</label>
                        <Field name="educationYear" type="text" className="form-control" placeholder="Enter Year (Ex: Jan 2020 - March 2024 )" />
                        <ErrorMessage name="educationYear" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Description</label>
                        <Field name="educationDescription"  className="form-control" component={JoditEditorComponent} type="text"  />
                        <ErrorMessage name="educationDescription" component="div" className="text-danger" />
                      </div>
                    </div>
                    <h6 className="mb-3">Experience</h6>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Designation</label>
                        <Field name="designation" type="text" className="form-control" placeholder="Enter Designation" />
                        <ErrorMessage name="designation" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Organization</label>
                        <Field name="organization" type="text" className="form-control" placeholder="Enter Organization Name" />
                        <ErrorMessage name="organization" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Current salary</label>
                        <Field name="currentSalary" type="number" className="form-control" placeholder="Enter Current Salary (In LPA)" />
                        <ErrorMessage name="currentSalary" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Duration</label>
                        <Field name="jobDuration" type="text" className="form-control" placeholder="Enter Deration (Ex: Jan 2024 - Sep 2025)" />
                        <ErrorMessage name="jobDuration" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label> Job Location</label>
                        <Field name="jobLocation" type="text" className="form-control" placeholder="Enter Organization Address" />
                        <ErrorMessage name="jobLocation" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Description</label>
                        <Field name="jobDescription"  className="form-control" component={JoditEditorComponent} type="text"  />
                        <ErrorMessage name="jobDescription" component="div" className="text-danger" />
                      </div>
                    </div>
                    <h6 className="mb-3">Projects 1</h6>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Projects Title</label>
                        <Field name="projecttitle1" type="text" className="form-control" placeholder="Enter Project Name" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Project Description</label>
                        <Field component={JoditEditorComponent} type="text"  name="projectdescription1" className="form-control" />
                      </div>
                    </div>
                    <h6 className="mb-3">Projects 2</h6>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Projects Title</label>
                        <Field name="projecttitle2" type="text" className="form-control" placeholder="Enter Project Name" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Project Description</label>
                        <Field type="text"  name="projectdescription2" className="form-control" component={JoditEditorComponent} />
                      </div>
                    </div>
                    <h6 className="mb-3">Social Links</h6>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Portfolio URL</label>
                        <Field name="portfolioUrl" type="text" className="form-control" placeholder="Enter Portfolio URL" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Linkedin URL</label>
                        <Field
                          name="linkedinUrl"
                          type="url"
                          className="form-control"
                          placeholder="Enter LinkedIn Profile URL"
                        />
                        <ErrorMessage name="linkedinUrl" component="div" className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mt-3">
                        <button type="submit" className="theme-btn">
                          <span className="far fa-paper-plane" /> Update Your Resume
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>

              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default MyResumeEdit
